import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

class Accessibility extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = 'Toegankelijkheid | Fietshelm';
  }

  render() {
    return (
      <React.Fragment>
        <Header title="Toegankelijkheid" />

        <main>
          <div className="container container--no-padding" id="inhoud">
            <div className="content">
              <h1 className="screen-reader">Toegankelijkheid</h1>
              
              <h2>Wet digitale overheid</h2>
              <p>Het ministerie van Infrastructuur en Waterstaat wil dat iedereen, zonder of met een permanente of tijdelijke functiebeperking, haar online diensten gemakkelijk kan gebruiken. Daarom werken we continu aan het verbeteren van de digitale toegankelijkheid op deze website. In de Wet digitale overheid staat dat websites van overheden moeten voldoen aan de toegankelijkheidseisen EN 301 549/WCAG 2.1. Overheden moeten daarover verantwoording afleggen in een gepubliceerde toegankelijkheidsverklaring.</p>
              
              <h2>Toegankelijkheidsverklaring</h2>
              <p>Op 27 maart 2025 is deze site onafhankelijk getoetst op toegankelijkheid. Bevindingen zijn meegenomen in de verklaring voor deze site, waarbij genoemde punten op dit moment zijn verwerkt.</p>
              
              <h2>Hoe wij de toegankelijkheid van deze website verbeteren</h2>
              <p>Vanuit het Ministerie van Infrastructuur en Waterstaat verbeteren wij de digitale toegankelijkheid door:</p>
              <ul>
                  <li><strong>Toegankelijkheid vanaf de start.</strong> Bij nieuwe websites letten we vanaf de start bij elke stap op de toegankelijkheid. Denk aan het ontwerp-, bouw en content.</li>
                  <li><strong>Onderzoek naar de status van de toegankelijkheid.</strong> Deskundigen onderzoeken (onderdelen van) de website op toegankelijkheid. Gevonden knelpunten lossen we waar mogelijk duurzaam op.</li>
                  <li><strong>Kennis bij medewerkers.</strong> Met een campagne voor onze medewerkers verhogen we de bewustwording over het belang van Digitale Toegankelijkheid en wat hierbij komt kijken. Voor diverse medewerkers maken wij opleidingen en e-learning beschikbaar.</li>
              </ul>
              
              <h2>Overzicht toegankelijkheidsverklaringen</h2>
              <p>In het dashboard digitoegankelijk vindt u toegankelijkheidsverklaringen van andere websites waar wij verantwoordelijkheid voor zijn.</p>
              <p>Bekijk het <a href="https://dashboard.digitoegankelijk.nl/organisaties/553">overzicht met verklaringen van het Ministerie van Infrastructuur en Waterstaat</a>.</p>

              <h2>Problemen met toegankelijkheid melden</h2>
              <p>Heeft u vragen of opmerkingen? Of wilt u een pagina gebruiken die niet toegankelijk is? Dan kunt u <a href="https://www.komveiligthuis.nl/service/contact">contact opnemen</a></p>
              <h2>Wat kunt u van ons verwachten?</h2>
              <p>Binnen 5 werkdagen krijgt u een ontvangstbevestiging. We informeren u over de voortgang en de uitkomst. Binnen 3 weken is uw verzoek afgehandeld.</p>

 
            </div>
          </div>
        </main>

        <Footer />
      </React.Fragment>
    );
  }
}

export default Accessibility;

